var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"centered-floating-box"},[_c('v-alert',{attrs:{"border":"top","color":"red lighten-2","dark":""}},[_c('b',[_vm._v("404")]),_c('br'),_vm._v(" Seite nicht gefunden ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }